"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8822],{

/***/ 8822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ EventsPage; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/VideoIcon-87fb4a33.mjs
var VideoIcon_87fb4a33 = __webpack_require__(4659);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-3122c134.mjs
var Icon_3122c134 = __webpack_require__(3355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/EventHero.js













const b = "registration", B = "registration__video-container", w = "registration__information", P = "button", u = {
  registration: b,
  registrationVideoContainer: B,
  registrationInformation: w,
  button: P
};
function W(c) {
  const {
    eventStartDate: s,
    eventEndDate: t,
    eventLocation: r,
    eventLink: n,
    translations: o = {},
    locale: a
  } = c, {
    location: v = "Location",
    time: g = "Time",
    link: p = "Register"
  } = o, { textDate: E, isMultiDayEvent: L } = A(
    s,
    t,
    a
  ), l = L ? void 0 : $(s, t, a);
  return /* @__PURE__ */ react.createElement("span", { className: u.registration }, /* @__PURE__ */ react.createElement("div", { className: u.registrationVideoContainer }, /* @__PURE__ */ react.createElement(
    VideoIcon_87fb4a33.V,
    {
      src: "/static/videos/Icon_Calendar.mp4",
      fallbackImgSrc: "/static/images/Icon_Calendar.svg"
    }
  )), /* @__PURE__ */ react.createElement(
    "dl",
    {
      className: (0,app_a75c1d35.c)(
        u.registrationInformation,
        app_a75c1d35.t.textsLeadText
      )
    },
    /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", { style: { display: "none" } }, "Date"), /* @__PURE__ */ react.createElement("dd", { className: app_a75c1d35.t.textsLeadTextBold }, E)),
    l ? /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", null, g, ": "), /* @__PURE__ */ react.createElement("dd", null, l)) : null,
    r ? /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", null, v, ": "), /* @__PURE__ */ react.createElement("dd", null, r)) : null,
    n ? /* @__PURE__ */ react.createElement(Link_479ac100.L, { href: n, disableLinkTextStyle: !0 }, /* @__PURE__ */ react.createElement(
      Button_c598cb52.B.Secondary,
      {
        asDiv: !0,
        text: p,
        icon: Icon_3122c134.W.ARROW_UP_RIGHT
      }
    )) : null
  ));
}
function A(c, s, t = "en-US") {
  const r = {
    weekday: void 0,
    year: "numeric",
    month: "long",
    day: "numeric"
  }, n = c.toLocaleDateString(t, r), o = s?.toLocaleDateString(t, r), a = o ? n !== o : !1;
  return {
    textDate: a ? `${n} — ${o}` : n,
    isMultiDayEvent: a
  };
}
function $(c, s, t = "en-US") {
  const r = new Intl.Locale(t), n = {
    timeStyle: "short",
    timeZone: "Europe/Helsinki"
  }, o = c.toLocaleTimeString(r, n).toLocaleLowerCase(), a = s?.toLocaleTimeString(r, n).toLocaleLowerCase();
  return !a || a === o ? o : `${o} - ${a}`;
}
const O = "event-hero-block-content", V = "event-hero-title", G = "event-hero", U = "desktop", M = "hero-wrapper", F = "image-reference", Z = "information", j = "registration", q = "event-hero-lead-text", z = "event-hero-description", J = "event-hero-link", i = {
  eventHeroBlockContent: O,
  eventHeroTitle: V,
  eventHero: G,
  desktop: U,
  heroWrapper: M,
  imageReference: F,
  information: Z,
  registration: j,
  eventHeroLeadText: q,
  eventHeroDescription: z,
  eventHeroLink: J
};
function le(c) {
  const {
    title: s,
    image: t,
    imageReference: r,
    leadText: n,
    description: o,
    altText: a,
    isLargeDesktop: v,
    locale: g,
    eventStartDate: p,
    eventEndDate: E,
    eventLocation: L,
    eventLink: l,
    translations: f = {}
  } = c, {
    link: y = "Register"
  } = f, C = (0,app_a75c1d35.c)(app_a75c1d35.t.pageHeading, i.eventHeroTitle), R = (0,app_a75c1d35.c)(i.imageReference), T = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsComponentTitleBold,
    i.eventHeroLeadText
  ), k = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsLeadText,
    i.eventHeroDescription
  );
  return /* @__PURE__ */ react.createElement(Block_9b78bd10.B, { bottomPadding: Block_9b78bd10.a.LARGE, topPadding: Block_9b78bd10.a.SMALL }, /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: i.eventHeroBlockContent }, /* @__PURE__ */ react.createElement("h1", { className: C }, s), /* @__PURE__ */ react.createElement("div", { className: i.heroWrapper }, /* @__PURE__ */ react.createElement(
    Image_d6406817.I,
    {
      className: i.eventHero,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: a,
      imageLoader: t.imageLoader,
      styling: Image_d6406817.a.ARTICLE_PAGE_HERO,
      "data-testid": "event-page-hero-image"
    }
  ), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: R,
      "data-testid": "event-hero-image-reference"
    },
    /* @__PURE__ */ react.createElement("p", { itemProp: "citation", className: app_a75c1d35.t.textsCaption }, r)
  )), /* @__PURE__ */ react.createElement(
    W,
    {
      locale: g,
      eventStartDate: p,
      eventEndDate: E,
      eventLocation: L,
      eventLink: l,
      translations: f
    }
  ), v ? /* @__PURE__ */ react.createElement("div", { className: i.information }, /* @__PURE__ */ react.createElement("p", { className: T }, n), /* @__PURE__ */ react.createElement("div", { className: k }, o)) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("p", { className: T }, n), /* @__PURE__ */ react.createElement("div", { className: k }, o), l ? /* @__PURE__ */ react.createElement("div", { className: i.eventHeroLink }, /* @__PURE__ */ react.createElement(Link_479ac100.L, { href: l, disableLinkTextStyle: !0 }, /* @__PURE__ */ react.createElement(
    Button_c598cb52.B.Secondary,
    {
      asDiv: !0,
      text: y,
      icon: Icon_3122c134.W.ARROW_UP_RIGHT
    }
  ))) : null)));
}

//# sourceMappingURL=EventHero.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/EventHero/EventHero.tsx









var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4288).then(__webpack_require__.bind(__webpack_require__, 4288));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4288)
            ];
        }
    }
});
function EventHero(props) {
    var eventDateStart = props.eventDateStart, eventDateEnd = props.eventDateEnd, image = props.image, heroTitle = props.heroTitle, heroDescription = props.heroDescription, eventLink = props.eventLink, eventLocation = props.eventLocation, eventLinkLabel = props.eventLinkLabel, eventLocationLabel = props.eventLocationLabel, eventTimeLabel = props.eventTimeLabel, altText = props.altText, imageReference = props.imageReference, leadText = props.leadText;
    var isLargeDesktop = (0,ViewportContext/* default */.Z)().viewport === app/* Viewport.xl */.l_.xl;
    var locale = (0,router.useRouter)().locale;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var imageData = imageDataHandler(image);
    var eventDateStartAsDate = new Date(eventDateStart);
    var eventDateEndAsDate = eventDateEnd ? new Date(eventDateEnd) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(le, {
        title: heroTitle,
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
            html: heroDescription
        }),
        image: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            imageSrc: imageData.src
        }),
        altText: altText,
        imageReference: imageReference,
        leadText: leadText,
        eventLink: eventLink,
        eventLocation: eventLocation,
        isLargeDesktop: isLargeDesktop,
        eventStartDate: eventDateStartAsDate,
        eventEndDate: eventDateEndAsDate,
        translations: {
            link: eventLinkLabel,
            location: eventLocationLabel,
            time: eventTimeLabel
        },
        locale: locale
    });
}

// EXTERNAL MODULE: ./src/util/SmartEditableArea.tsx
var SmartEditableArea = __webpack_require__(1747);
;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/EventsPage.tsx







function EventsPage(props) {
    var ref;
    var title = props.title, metaDescription = props.metaDescription, main = props.main, altText = props.altText, image = props.image, isPreview = props.isPreview;
    var articleImageUrl = (image === null || image === void 0 ? void 0 : (ref = image.renditions) === null || ref === void 0 ? void 0 : ref["xs"]) ? (0,magnolia/* formatAssetLink */.Qz)(image.renditions["xs"].link, isPreview) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title + app/* META_TITLE_SUFFIX */.A_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    articleImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: articleImageUrl
                    }),
                    altText && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: altText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventHero, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
                isPreview: isPreview,
                slotNode: main
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmartEditableArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _magnolia_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9647);





var EditableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(7351)]).then(__webpack_require__.bind(__webpack_require__, 7351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7351)
            ];
        }
    }
});
function SmartEditableArea(props) {
    var slotNode = props.slotNode, isPreview = props.isPreview;
    if (isPreview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditableArea, {
                className: "EditableArea",
                content: slotNode
            })
        });
    }
    var pageNodes = ((slotNode === null || slotNode === void 0 ? void 0 : slotNode["@nodes"]) || []).map(function(name) {
        return slotNode === null || slotNode === void 0 ? void 0 : slotNode[name];
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: pageNodes.map(function(node) {
            var NodeComponent = (0,_magnolia_config__WEBPACK_IMPORTED_MODULE_3__/* .getComponentForMagnoliaTemplate */ .rX)(node["mgnl:template"]);
            if (!NodeComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, node), node["@id"]);
        })
    });
}


/***/ })

}]);